import React from "react";
import MenuNav from "../components/Menunav";
import MobileMenu from "../components/MobileMenu";
import FooterOutils from "../components/Footer";
export default function Contact() {
  return (
    <>
      <MenuNav />
      <MobileMenu />

      <div className="container py-5">
        <h2 className="text-center mb-4">📞 Contactez-nous</h2>

        <div className="row g-4">
          {/* Formulaire de contact */}
          <div className="col-md-6">
            <div className="card shadow-sm p-4">
              <h5 className="mb-3">Envoyez-nous un message</h5>
              <form>
                <div className="mb-3">
                  <label className="form-label">Nom</label>
                  <input type="text" className="form-control" placeholder="Votre nom" required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-control" placeholder="Votre adresse email" required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Message</label>
                  <textarea className="form-control" rows="4" placeholder="Votre message..." required></textarea>
                </div>
                <button type="submit" className="btn btn-success">Envoyer</button>
              </form>
            </div>
          </div>

          {/* Informations de contact */}
          <div className="col-md-6">
            <div className="card shadow-sm p-4 h-100">
              <h5 className="mb-3">Nos coordonnées</h5>
              <p><strong>📍 Adresse :</strong> Lomé, Togo</p>
              <p><strong>📞 Téléphone :</strong> <a href="tel:+22892076072">+22892076072</a></p>
              <p><strong>📧 Email :</strong> <a href="mailto:contact@tonsite.com">contact@lafape.com</a></p>

              <div className="ratio ratio-4x3 rounded mt-3">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18..."
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  title="Carte Google"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterOutils />
    </>
  );
}
